import { useFormExpanded } from './useForm';
import type { FormInstance } from 'antd';
import { Form } from 'antd';
import type { NamePath } from 'antd/lib/form/interface';
import { useCallback } from 'react';

export function useFormArray<T>({ field, form }: { field: NamePath; form: FormInstance }) {
  const { setFormValue } = useFormExpanded({ form });
  const value = Form.useWatch(field, form) as T[];

  const add = useCallback(
    (value: T | T[]) => {
      const currentValue = form.getFieldValue(field);
      if (Array.isArray(currentValue)) {
        setFormValue(field, [...currentValue, ...(Array.isArray(value) ? value : [value])]);
      }
    },
    [form, field, setFormValue],
  );

  const remove = useCallback(
    (value: T | T[]) => {
      const currentValue = form.getFieldValue(field);
      if (Array.isArray(currentValue)) {
        setFormValue(
          field,
          currentValue.filter((item) => (Array.isArray(value) ? !value.includes(item) : item !== value)),
        );
      }
    },
    [form, field, setFormValue],
  );

  return { value, add, remove };
}
